angular.module('mean.general-tasks').filter('myCurrency', ['$filter',
    function ($filter) {
    return function (val) {
        val  = !!val ? val : 0.00;

        var decimalPart = val.toString().split('.')[1];

        //no decimal part so just return $ 0.00
        if(!decimalPart)
            return '$ ' + $filter('number')(val, 2);

        decimalPart = decimalPart.trim();
        if(decimalPart.length > 2)
            return '$ ' + $filter('number')(val, 4);
        else
            return '$ ' + $filter('number')(val, 2);
    };
}]);



// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/filters/my-currency.js